import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { styled, alpha } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import InputBase from '@mui/material/InputBase'
import MenuIcon from '@mui/icons-material/Menu'
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import Popover from '@mui/material/Popover'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

import '../styles/components/topBar.scss'

import AddCocktail from './AddCocktail'
import axios from 'axios'

const TopBar = ({ setCocktails, isSearching }) => {
  const [modal, setModal] = useState(false)
  const [text, setText] = useState('')
  const [anchorEl, setAnchorEl] = useState(null)

  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setError(false)
    setPassword('')
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const connected = sessionStorage.getItem('profil') || false

  const handleInputChange = (event) => {
    setText(event.target.value)
    isSearching(event.target.value !== '')
  }

  useEffect(() => {
    if (!text) {
      return
    }
    axios({
      method: 'get',
      url: `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/api/cocktails/search/${text}`,
    })
      .then((res) => {
        setCocktails(res.data)
      })
      .catch((error) => {
        setCocktails([])
      })
  }, [text])

  const handleSubmit = (event) => {
    event.preventDefault()

    axios({
      method: 'post',
      url: `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/api/auth/`,
      data: { password: password },
    })
      .then((res) => {
        sessionStorage.setItem('profil', res.data.profil)
        sessionStorage.setItem('token', res.data.token)
        handleClose()
      })
      .catch((error) => {
        setError(true)
        setPassword('')
      })
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            Cocktail
          </Typography>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              value={text}
              type="text"
              name="cocktailName"
              onChange={handleInputChange}
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search>

          {connected ? (
            <IconButton size="large" color="inherit" sx={{ mr: 1 }}>
              <AddIcon onClick={() => setModal(true)} />
              <AddCocktail modal={modal} setModal={setModal} />
            </IconButton>
          ) : (
            <></>
          )}

          <IconButton id={id} size="large" color="inherit" sx={{ mr: 1 }}>
            <AccountCircleIcon onClick={handleClick} />
          </IconButton>
          <Popover
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
          >
            {connected ? (
              'Vous êtes connecté'
            ) : (
              <form className="passwordForm" onSubmit={handleSubmit}>
                <TextField
                  error={error}
                  helperText={error ? 'Entrée incorrecte' : ''}
                  className="outlined-password-input"
                  label="Mot de passe"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value)
                    setError(false)
                  }}
                />
                <Button type="submit" variant="outlined">
                  Valider
                </Button>
              </form>
            )}
          </Popover>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

TopBar.propTypes = {
  setCocktails: PropTypes.func.isRequired,
  isSearching: PropTypes.func.isRequired,
}

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}))

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '30ch',
      },
    },
  },
}))

export default TopBar
